import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = ({ service }) => {
  const [openFAQ, setOpenFAQ] = useState(null);

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <div className="bg-white rounded-xl shadow-soft border border-border p-8">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 rounded-full gradient-primary flex items-center justify-center">
          <Icon name="HelpCircle" size={20} color="white" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">
            Frequently Asked Questions
          </h3>
          <p className="text-sm text-muted-foreground">
            Common questions about our {service.title} services
          </p>
        </div>
      </div>

      <div className="space-y-4">
        {service.faqs.map((faq, index) => (
          <div key={index} className="border border-border rounded-lg">
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full flex items-center justify-between p-4 text-left hover:bg-muted/50 transition-smooth"
            >
              <span className="font-medium text-foreground pr-4">
                {faq.question}
              </span>
              <Icon 
                name={openFAQ === index ? "ChevronUp" : "ChevronDown"} 
                size={20} 
                className="text-muted-foreground flex-shrink-0" 
              />
            </button>
            
            {openFAQ === index && (
              <div className="px-4 pb-4">
                <div className="pt-2 border-t border-border">
                  <p className="text-muted-foreground leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-primary/5 rounded-lg">
        <div className="flex items-start space-x-3">
          <Icon name="MessageSquare" size={16} className="text-primary mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-sm text-foreground font-medium mb-1">
              Have more questions?
            </p>
            <p className="text-xs text-muted-foreground">
              Our experts are here to help. Schedule a consultation to discuss your specific needs.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;